import React from 'react';
import { Activity, UserRole, Users } from '../../types';
import ToolsPage from '../uitools/ToolsPage';
import ObjectCam from '../uiobjects/ObjectCam';
import ObjectReturn from '../uiobjects/ObjectReturn';
import UsersAndWarehouses from '../users/UsersAndWarehousesAndClasses';


interface ActivityViewProps {
  activity: Activity | undefined;
  logout: ()=>boolean;
  role: UserRole;
  token: string | null;
}

const ActivityView: React.FC<ActivityViewProps> = ({ token,role,activity, logout }) => {
  if (!activity) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-semibold text-slate-700">Seleziona un'attività</h2>
        <p className="text-slate-500 mt-2">Scegli un'opzione dal menu laterale per iniziare.</p>
      </div>
    );
  }

  const { label, icon: Icon, description, value } = activity;

  return (
      
      <div className="p-8 flex-1 overflow-y-auto overflow-x-hidden">
      
      {value===0 && <ObjectCam token={token!}/>}
      {value===1 && <ToolsPage token={token!} role={role}/>}
      {value===2 && <ObjectReturn token={token!}/>}
      {value===3 && <UsersAndWarehouses token={token!}/>}
      {value===5 && (
        <div>
          <header className="mb-8 pb-4 border-b border-slate-300">
              <div className="flex items-center space-x-3">
                <Icon className="h-10 w-10 text-sky-600" />
              <h1 className="text-4xl font-bold text-slate-800">{label}</h1>
              <h4>View</h4>
              </div>
          </header>
        </div>
      )}
      {value===4 && (
        <div>
          <header className="mb-8 pb-4 border-b border-slate-300">
              <div className="flex items-center space-x-3">
                <Icon className="h-10 w-10 text-sky-600" />
              <h1 className="text-4xl font-bold text-slate-800">{label}</h1>
              <h4>Bye bye!</h4>
              </div>
          </header>
        </div>
      ) && logout()}
    </div>
  );
};

export default ActivityView;